import App from './app';
import LazyImg from './classes/class-lazy-image';

const lazyObserver = (() => {
  const nodes = document.querySelectorAll('.js-lazy-img, .js-lazy-iframe, .js-observe');
  const actions = {
    visible: (node) => {
      node.classList.add('is-visible');
      return node;
    },
    image: (node) => {
      const { src, alt, title } = node.dataset;
      const altAttr = alt || node.alt || '';
      const titleAttr = title || node.title || '';
      return new LazyImg(node, src, (loadedImg) => {
        const img = loadedImg;
        const classes = `${node.getAttribute('class')} a-opacity is-loaded`;
        img.style.cssText = node.style.cssText;
        img.setAttribute('class', classes);
        img.alt = altAttr || titleAttr || '';
        img.title = titleAttr || altAttr || '';
      }, () => {
        node.classList.add('is-error');
      });
    },
    iframe: (node) => {
      const { src } = node.dataset;
      const iframe = document.createElement('iframe');
      const classes = `${node.getAttribute('class')} a-opacity`;
      iframe.src = src;
      iframe.style.cssText = node.style.cssText;
      iframe.setAttribute('class', classes);
      if (node.parentNode) {
        node.parentNode.replaceChild(iframe, node);
      }
    },
  };
  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        const entryClass = entry.target.classList;
        if (entryClass.contains('js-observe')) {
          entry.target.classList.remove('js-observe');
          return actions.visible(entry.target);
        }
        if (entryClass.contains('js-lazy-img')) {
          entry.target.classList.remove('js-lazy-img');
          return actions.image(entry.target);
        }
        if (entryClass.contains('js-lazy-iframe')) {
          entry.target.classList.remove('js-lazy-iframe');
          return actions.iframe(entry.target);
        }
      }
      return entry.target;
    });
  };
  const server = new IntersectionObserver(observerCallback, {
    root: null,
    rootMargin: '0% 0px',
    threshold: 0.1,
  });
  [...nodes].forEach(node => server.observe(node));
  return server;
})();

(($) => {
  App.stream.add((context) => {
    if (context) {
      const $context = $(context);
      const $nodes = $context.find('.js-lazy-img, .js-lazy-iframe, .js-observe');
      $nodes.each(function () {
        lazyObserver.observe($(this)[0]);
      });
    }
  });
})(jQuery);

export default lazyObserver;
